import type { WalkingPathActionKind } from "@cs2/physics";

/**
 * Symbole für Bewegungsaktionen auf dem Laufweg als reine Strichpfade
 * (24er-Raster) — wie `grenade-paths.ts` ohne JSX, damit Konva und SVG
 * dieselben Daten zeichnen.
 */
export const movementGlyphViewBox = 24;

export const movementGlyphs: Record<WalkingPathActionKind, string> = {
  jump: "M12 19V6M6.5 11.5 12 6l5.5 5.5",
  "crouch-jump": "M6.5 12 12 6.5l5.5 5.5M6.5 18 12 12.5l5.5 5.5",
  "run-jump": "M4 17Q12 3 20 17M20 17l-.5-5M20 17l-5-.5",
  drop: "M12 5v13M6.5 12.5 12 18l5.5-5.5",
  ladder: "M8 4v16M16 4v16M8 8h8M8 12h8M8 16h8",
};

export const movementLabels: Record<WalkingPathActionKind, string> = {
  jump: "Sprung",
  "crouch-jump": "Crouch-Jump",
  "run-jump": "Weitsprung",
  drop: "Drop",
  ladder: "Leiter",
};
